import { Check, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { BrandLogo } from '@/components/brand/brand-logo';
import { LanguageToggle } from '@/components/navigation/language-toggle';

export function AuthLayout() {
  const { t } = useTranslation('auth');
  return (
    <div className="auth-layout">
      <header className="auth-header">
        <BrandLogo />
        <LanguageToggle />
      </header>
      <main id="main-content" className="auth-main">
        <section className="auth-form-panel">
          <div className="auth-form-wrap">
            <Outlet />
          </div>
        </section>
        <aside className="auth-story-panel">
          <div className="auth-story-panel__grid" aria-hidden="true" />
          <div className="auth-story-panel__content">
            <span className="auth-story-panel__icon">
              <ShieldCheck size={25} />
            </span>
            <h2>{t('panel.title')}</h2>
            <p>{t('panel.body')}</p>
            <ul>
              <li>
                <Check size={17} /> {t('panel.profile')}
              </li>
              <li>
                <Check size={17} /> {t('panel.scores')}
              </li>
              <li>
                <Check size={17} /> {t('panel.privacy')}
              </li>
            </ul>
          </div>
          <div className="auth-story-card" aria-hidden="true">
            <div>
              <span>{t('panel.cvLabel')}</span>
              <strong>82</strong>
            </div>
            <div>
              <span>{t('panel.jobMatchLabel')}</span>
              <strong>78%</strong>
            </div>
            <i />
          </div>
        </aside>
      </main>
    </div>
  );
}
